<template>
  <v-container>
    <v-layout>
      <v-card>
        <v-card-title>{{ $t("form.success.headline") }}</v-card-title>
        <v-card-text>{{ $t("form.success.close") }}</v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      window.close();
    }, 2500);
  }
};
</script>

<style></style>
